import { render, staticRenderFns } from "./MassActionComponent.vue?vue&type=template&id=165ba5cc&"
import script from "./MassActionComponent.vue?vue&type=script&lang=js&"
export * from "./MassActionComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports